import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario_detalle/get/all`);
  return response;
};

const getByHorarioId = async (horarioId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario_detalle/horario/${horarioId}`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario_detalle/${id}`);
  return response;
};

const createOrUpdate = async (data) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_horario_detalle`, data);
  return response;
}

const update = async (id, data) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo_horario_detalle/${id}`, data);
  return response;
}

const deleteById = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}odoo_horario_detalle/${id}`);
  return response;
}

export {getAll, getByHorarioId, getById, createOrUpdate, update, deleteById};